import { CountryData } from "./country";
import { CurrencyData } from "./currency";
import { AccountStatus, Counts, Error } from './data';

export class Admin {
    success: true|false;
    results: string;
    error: Error;
    counts: Counts
    data: AdminData[] = [];
}

export class OneAdmin {
  success: true|false;
  error: Error;
  results: string;
  data: AdminData;
}

export class AdminData {
    ref: number;
    token: {
        token: string,
        refresh: string
    };
    username: string;
    nickName: string;
    lastName: string;
    firstName: string;
    email: string;
    publicKey: string;
    country: AdminCountry;
    rights: AdminRightData;
    stats: {
        users: {
            new: number;
            pending: number;
            complete: number;
            active: number;
            inactive: number;
        }
    };
    notification: {
        total: number,
        KYC: number
    };
    accountStatus: AccountStatus;
    created: string;
    lastModified: string;

    constructor() {
        this.country = new AdminCountry();
        this.rights = new AdminRightData();
        this.accountStatus = new AccountStatus();
    }
}

export class AdminCountry {
    ref: number;
    title: string;
    iso: string;
    currency: CurrencyData;
    online: boolean;

    constructor() {
        this.currency = new CurrencyData();
    }
}

export class AdminMiniData {
    userId: number;
    username: number;
    firstName: string;
    lastName: string;
}

export class AdminRight {
    success: true|false;
    results: string;
    error: Error;
    data: AdminRightData[] = [];
}

export class AdminRightData {
    ref: number;
    adminType: string;
    slug: string;
    mainPage: string;
    super: boolean;
    read: boolean;
    write: boolean;
    modify: boolean;
    status: string;
    pages: string[];
    countryList: CountryListData[] = [];
    createdBy: AdminMiniData;
    lastModifiedBy: AdminMiniData;
    created: string;
    lastModified: string;

    constructor() {
        this.createdBy = new AdminMiniData();
        this.lastModifiedBy = new AdminMiniData();
    }
}

export class CountryListData {
    iso: string;
    name: string;
}

export class AllowedRightData {
    success: boolean;
    results: string;
    data: {
        country: CountryData[];
        pages: string[];
    };
}


export class PasswordData {
    success: true|false;
    error: Error;
    results: string;
    message: string;
  }
